import React, { FC, useEffect, useState } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { useAuthUser } from '@yakoffice/yakoffice-firebase';
import { BuildsRouteItems } from '../../routes';
import { MobileNavigation } from '../../../views/components/mobileNavigation/mobile-navigation';
import styles from './project.module.scss';
import { NavigationRail } from '@yakoffice/navigation-rail';
import { useProjectThemeContext } from '@yakoffice/project-theme';
import { Builds } from '../../../views/builds/builds';

export const BuildsContainer: FC = () => {

    const { projectId } = useParams<{ projectId: string }>();
    const authUser = useAuthUser();
    const isMiniclipPublicUser: boolean = !authUser || !authUser.isAuthorisedForHostedToolProject(projectId);
    const [isMobile, setIsMobile] = useState(document.documentElement.clientWidth < 768);
    const projectTheme = useProjectThemeContext();

    useEffect(() => {
        window.addEventListener('resize', () => setIsMobile(window.innerWidth < 768));
    }, []);

    return (
        <div className={`${styles.project} project ${projectTheme.getColor()}`}>
            {!isMobile && <NavigationRail toolId="builds" />}
            <Routes>
                <Route path={''} element={<Builds isMobile={isMobile} />} />
                <Route path={BuildsRouteItems.BuildIdParam} element={<Builds isMobile={isMobile} />} />
            </Routes>
            {isMobile && <MobileNavigation />}
        </div>
    );
};
